export const DEFAULT_OPUS_PACKAGE_CONFIG = {
  sampleRate: 48000,
  channels: 1,
  frameSize: 960, // 20ms at 48kHz (960 samples = 20ms)
  applicationVoip: 2048,
} as const;

// ScriptProcessor buffer must be a power of two (256..16384); frames are re-chunked to frameSize
export const SCRIPT_PROCESSOR_BUFFER_SIZE = 1024;

export const CallWsEvent = {
  ConnectionReady: 'connection.ready',
  SessionJoin: 'session.join',
  AgentTranscript: 'agent.transcript',
  CustomerTranscript: 'customer.transcript',
  SessionReady: 'session.ready',
  SessionClose: 'session.close',

  Exception: 'exception',
} as const;

export const WsErrorCode = {
  AuthenticationError: 'authentication.error',
} as const;

export const WS_POLICY_VIOLATION_CLOSE_CODE = 1008;
